import { SnotifyService } from 'ng-snotify';
import { Validators } from '@angular/forms';
import { DVFormGroup, DVFormControl } from 'src/app/shared/helpers/dynamic-validators/dynamic-validator';
import { InquiryService } from './../../../services/inquiry.service';
import { Router } from '@angular/router';
import { Component, OnInit, Input, ViewChild, ElementRef, EventEmitter, Output, OnChanges } from '@angular/core';

@Component({
  selector: 'app-view-inquiry',
  templateUrl: './view-inquiry.component.html',
  styleUrls: ['./view-inquiry.component.css']
})
export class ViewInquiryComponent implements OnInit, OnChanges {

  @Input() inquiryRow;
  @ViewChild('modal', { static: false }) modal: ElementRef;
  @ViewChild('closeViewModal', { static: false })
  closeViewModal: ElementRef;
  @Output() return = new EventEmitter();


  statusForm: DVFormGroup;
  statusChanged = false;
  currentStatus = '';
  update = {} as any;


  inquiry: ViewInquiry;
  rowAcc: any;
  inquiryStatus = [
    { value: 'NEW', display: 'New' },
    { value: 'CLOSED_CONFIRMED', display: 'Closed Confirmed' },
    { value: 'CLOSED_LOST', display: 'Closed Lost' },
    { value: 'PENDING_CUSTOMER_REPLY', display: 'Pending Customer Reply' },
    { value: 'PENDING_CS_REPLY', display: 'Pending CS Reply' },
    { value: 'NON_SALES_INQUIRY', display: 'Non Sales Inquiry' }
  ];
  constructor(
    private inquiryService: InquiryService,
    private router: Router,
    private notifier: SnotifyService
  ) {

    this.statusForm = new DVFormGroup({
      status: new DVFormControl(null, {
        'Status is required': Validators.required
      }),
      paidAmount: new DVFormControl(null),
      lostReason: new DVFormControl(null)
    });
  }

  ngOnInit() {
    this.setStatusValidators();
  }

  ngOnChanges(): void {
    this.inquiry = null;
    this.update = {};
    this.inquiryService
      .getInquiry(this.inquiryRow.id)
      .subscribe(Response => {
        this.inquiry = Response.data.inquiry;
        this.statusForm.get('status').setValue(this.inquiry.status);
        this.statusForm.get('paidAmount').setValue(this.inquiry.paidAmount);
        this.statusForm.get('lostReason').setValue(this.inquiry.lostReason);
        this.currentStatus = this.inquiry.status;
      });
  }

  SubmitForm() {
    if (this.statusForm.invalid) {
      this.statusForm.forceShowErrors();
      return;
    }

    this.update = {
      id: this.inquiry.id,
      status: this.statusForm.get('status').value
    };
    switch (this.currentStatus) {
      case 'CLOSED_CONFIRMED':
        this.update.paidAmount = this.statusForm.get('paidAmount').value;
        break;
      case 'CLOSED_LOST':
        this.update.lostReason = this.statusForm.get('lostReason').value;
        break;
    }

    this.inquiryService.changeStatus(this.update).subscribe(res => {
      this.notifier.success('Status Changed Successfully');
      this.return.emit({ flag: true });
    }, err => {
      this.notifier.error(err.error.userMessage);
    });
    this.closeViewModal.nativeElement.click();
  }

  onOptionsSelected(value: string) {
    this.currentStatus = value;
    this.statusChanged = true;
  }

  setStatusValidators() {
    const paidAmountControl = this.statusForm.get('paidAmount') as DVFormControl;
    const lostReasonControl = this.statusForm.get('lostReason') as DVFormControl;

    this.statusForm.get('status').valueChanges
      .subscribe(status => {
        switch (status) {
          case 'CLOSED_CONFIRMED':
            paidAmountControl.addValidators({
              'Paid Amount is required': Validators.required
            });
            lostReasonControl.setValidators(null);
            break;
          case 'CLOSED_LOST':
            lostReasonControl.addValidators({
              'Closed Lost is required': Validators.required
            });
            paidAmountControl.setValidators(null);
            break;
          default:
            lostReasonControl.setValidators(null);
            paidAmountControl.setValidators(null);
            break;
        }
        paidAmountControl.updateValueAndValidity();
        lostReasonControl.updateValueAndValidity();
      });
  }
}

interface ViewInquiry {
  id: number;
  fullName: string;
  email: string;
  type: string;
  message: string;
  numberOfAdults: number;
  numberOfChilds: number;
  arrivalDate: Date;
  departureDate: Date;
  form: string;
  status: string;
  lostReason: string;
  Country: any;
  paidAmount: string;
  Experiences: [];
}
